// src/components/Company/OpportunityDrawer/HowItWorks.jsx

import React from "react";
import { useMediaQuery, Box, Typography } from "@mui/material";
import icon1 from "./assets/hiw-01.png";
import icon2 from "./assets/hiw-02.png";
import icon3 from "./assets/hiw-03.png";

const useStyles = ({ isSM }) => ({
  container: {
    width: "100%",
    maxWidth: "1200px",
    margin: "0 auto",
    boxSizing: "border-box",
  },
  title: {
    textAlign: "center",
    fontWeight: 600,
    fontSize: '32px',
    color: '#232B35',
    marginTop: '30px',
    marginBottom: '15px',
  },
  stepsContainer: {
    display: "flex",
    justifyContent: isSM ? "center" : "space-between",
    flexDirection: isSM ? "column" : "row",
    alignItems: isSM ? "stretch" : "flex-start",
    gap: "16px",
  },
  step: {
    flex: 1,
    display: "flex",
    flexDirection: isSM ? "row" : "column",
    alignItems: isSM ? "flex-start" : "center",
    textAlign: isSM ? "left" : "center",
    marginBottom: isSM ? "20px" : "0",
  },
  stepIcon: {
    width: "84px",
    height: "84px",
    objectFit: "cover",
    marginBottom: isSM ? "0" : "12px",
    marginRight: isSM ? "12px" : "0",
  },
  stepText: {
    display: "flex",
    flexDirection: "column",
    alignItems: isSM ? "flex-start" : "center",
    textAlign: isSM ? "left" : "center",
  },
  stepTitle: {
    fontSize: "16px",
    fontWeight: 600,
    margin: "4px 0",
    color: "#232B35",
  },
  stepDescription: {
    fontSize: "13px",
    fontWeight: 400,
    color: "#232B35",
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "center",
    marginTop: "24px",
  },
});

const HowItWorks = ({ button }) => {
  const isSM = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const classes = useStyles({ isSM });

  const steps = [
    {
      icon: icon1,
      title: "1. Become a board member",
      description:
        "Join our advisory board and share ideas at any time in our digital boardroom.",
    },
    {
      icon: icon2,
      title: "2. Share your ideas",
      description:
        "You’ll get a monthly update with what’s new that we could use fresh ideas on.",
    },
    {
      icon: icon3,
      title: "3. Enjoy the rewards & excitement",
      description:
        "Enjoy the potential perks and benefits of being on our advisory board.",
    },
  ];

  return (
    <Box sx={classes.container}>
      <Typography sx={classes.title}>How It Works</Typography>

      <Box sx={classes.stepsContainer}>
        {steps.map((step, idx) => (
          <Box key={idx} sx={classes.step}>
            <Box
              component="img"
              src={step.icon}
              alt={step.title}
              sx={classes.stepIcon}
            />

            <Box sx={classes.stepText}>
              <Typography sx={classes.stepTitle}>
                {step.title}
              </Typography>
              <Typography sx={classes.stepDescription}>
                {step.description}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>

      <Box sx={classes.buttonWrapper}>{button}</Box>
    </Box>
  );
};

export default HowItWorks;
